import mixpanel from 'mixpanel-browser';

const UTM_STORAGE_KEY = 'faye:utm';

let initialized = false;

export function initMixpanel() {
    const token = process.env.REACT_APP_MIXPANEL_TOKEN;
    if (!token) {
        console.warn('[mixpanel] REACT_APP_MIXPANEL_TOKEN not set — tracking disabled');
        return;
    }

    const apiHost = process.env.REACT_APP_MIXPANEL_API_HOST;

    if (apiHost) {
        window.MIXPANEL_CUSTOM_LIB_URL = `${apiHost}/lib.min.js`;
    }

    mixpanel.init(token, {
        ...(apiHost ? { api_host: apiHost } : {}),
        debug: process.env.NODE_ENV === 'development',
        ignore_dnt: true,
        persistence: 'localStorage',
    });

    const version = process.env.REACT_APP_VERSION;
    if (version) {
        mixpanel.register({ version });
    }

    captureUtmFromQuery();
    replayStoredUtm();

    initialized = true;
}

function captureUtmFromQuery() {
    if (!window.location.search) {
        return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const utm = {};
    let hasUtm = false;

    for (const [key, value] of searchParams) {
        if (key.startsWith('utm_') && !utm[key]) {
            utm[key] = value;
        } else if (key === 'ref') {
            utm.ref = value;
            utm.utm_medium = 'product_features';
            utm.utm_source = 'share_earn';
        } else {
            continue;
        }
        hasUtm = true;
    }

    if (hasUtm) {
        window.localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utm));
    }
}

function replayStoredUtm() {
    const utmJson = window.localStorage.getItem(UTM_STORAGE_KEY);
    if (!utmJson) {
        return;
    }

    try {
        const utm = JSON.parse(utmJson);
        mixpanel.people.set(utm);
        mixpanel.register(utm);
    } catch (e) {
        console.error('Error parsing stored UTM', e);
    }
}

export function getStoredUtm() {
    try {
        const utmJson = window.localStorage.getItem(UTM_STORAGE_KEY);
        return utmJson ? JSON.parse(utmJson) : {};
    } catch (e) {
        return {};
    }
}

export function mixpanelTrack(eventName, properties) {
    if (initialized) {
        mixpanel.track(eventName, properties);
    }
    // Mirror every event to the dataLayer for GTM (fires regardless of Mixpanel state)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...properties });
}

export function mixpanelIdentify(email, profile = {}) {
    if (!email) return;
    if (initialized) {
        mixpanel.identify(email);
        mixpanel.people.set({
            $email: email,
            ...(profile.firstName && { $first_name: profile.firstName }),
            ...(profile.lastName && { $last_name: profile.lastName }),
        });
    }
    // Mirror identify to the dataLayer for GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'identify', distinct_id: email });
}
